// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"b656e6e2","214":"1d79ee49"}[chunkId] + ".chunk.js";
};